import Box from '@material-ui/core/Box';
import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_DATE_FORMAT } from 'globalconfig/constants/static';
import { objectArrayFromMultipleFields, removeListItem } from 'globalutils/fmUtils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { columns, eldList } from './config';
import { checkServiceProvider } from './serviceProviderConfig';
import Toggle from './Toggle';
import TopActions from './TopActions';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  apiStatus,
  callback,
  fetchDailyDocuments,
  saveDocument,
  i18n,
  history,
  dailyDocuments,
  handleDeleteAlert,
  filterEldSuccess,
  Styled,
  topAction,
  currentDriver,
  setModalObject,
  ModalObject,
  closeModal,
  clickedModal,
  open,
  setOpen,
  filterByDriverAndDate,
  setbackgroundModal,
  withCloseIcon,
  backgroundModal,
  setwithCloseIcon,
  pagination,
  setPagination,
}) => {
  const [currentEld, setCurrentEld] = useState('all');

  useEffect(() => {
    const filteredDtos =
      currentEld !== 'all'
        ? dailyDocuments?.dailyDocumentsList?.filter((item) => {
            return item.type === i18n.t(`eld.${currentEld}`);
          })
        : dailyDocuments?.dailyDocumentsList;
    filterEldSuccess(filteredDtos, currentEld);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEld]);

  const drivers = objectArrayFromMultipleFields(dailyDocuments?.driversList, 'id', ['firstName', 'lastName']);

  const generateRows = (data) => {
    const updatedList = data?.map((item) => {
      var result = { ...item };
      result.receipt = (
        <img alt='eldicon' src={getMediaPath(mediaUrls.eldIcon)} onClick={() => window.open(item.link, '_blank')} />
      );
      result.driver = (
        <>
          <p className="driver">{item.driver}</p>
          <p className="date">{`${i18n.t('Uploaded')} ${moment(item.date).format(UI_DATE_FORMAT)}`}</p>
        </>
      );
      result.date = moment(item.date).format(UI_DATE_FORMAT);
      result.customer = (
        <>
          <p>{item.customerName}</p>
          <p>{item.customerJob}</p>
        </>
      );
      return result;
    });
    return updatedList || [];
  };

  const otherItems = removeListItem([...columns], 'id', 'customer');

  const checkEs = () => {
    let isEs = localStorage.getItem(window.$environment?.SERVICE_PROVIDER + 'Language') == 'es';
    if (checkServiceProvider('comp_checkEs', window.$environment?.SERVICE_PROVIDER, false) && isEs) return '_es';
    else return '';
  };

  return (
    <Styled.DailyLogContainer>
      {topAction && (
        <TopActions
          {...{
            history,
            apiStatus,
            fetchDailyDocuments,
            callback,
            drivers,
            currentDriver,
            Styled,
            i18n,
            saveDocument,
            setModalObject,
            ModalObject,
            closeModal,
            clickedModal,
            open,
            setOpen,
            dailyDocuments,
            filterByDriverAndDate,
            setwithCloseIcon,
            setbackgroundModal,
            withCloseIcon,
            backgroundModal,
            pagination,
            setPagination,
          }}
        />
      )}
      <div className="displayContainer">
        <Styled.EldContainer>
          <SubHeader text={i18n.t('ELD')} variant="h2" />
          <div className="eldList">
            {eldList.map((item, index) => (
              <Toggle
                src={item + `_active${checkEs()}.svg`}
                setCurrentEld={(data) => {
                  setCurrentEld(data);
                  setPagination(true);
                }}
                item={item}
                i18n={i18n}
                selected={currentEld === item}
              />
            ))}
          </div>
          <div className="mainContainer">
            <Table
              type="client"
              defaultSortBy={{ sortBy: 'date', order: 'desc' }}
              title=""
              columns={[...columns]}
              itemsPerPage={5}
              data={generateRows(dailyDocuments?.dailyDocumentsFilteredList)}
              emptyMessage={i18n.t('common.tableEmptyMessage')}
              isPaginationNeeded="true"
              pageinationReset={pagination}
              pagenationClicked={(e) => {
                setPagination(!e);
              }}
              actions={[
                {
                  icon: (row) => {
                    return (
                      <Icon
                        src={mediaUrls?.deleteIcon}
                        onClick={() => {
                          setwithCloseIcon(false);
                          setbackgroundModal(true);
                          setModalObject({
                            content: () => (
                              <div className="deleteParent">
                                <div className="imageSection">
                                  <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                                </div>
                                <h2> {i18n.t('common.sureConfirm')} </h2>
                                <div className="deletePopupBtn">
                                  <div className="cancelBtn">
                                    <Button
                                      label={i18n.t('Cancel')}
                                      type={'reset'}
                                      onClick={() => {
                                        closeModal();
                                      }}
                                    ></Button>
                                  </div>
                                  <div className="deletebtn">
                                    <Button
                                      label={i18n.t('common.deletePopup')}
                                      onClick={() => {
                                        handleDeleteAlert({
                                          id: 'deleteAlert',
                                          data: {
                                            id: row?.documentId,
                                            type: row?.type,
                                          },
                                          callback: callback,
                                        });
                                        closeModal();
                                      }}
                                    ></Button>
                                  </div>
                                </div>
                              </div>
                            ),
                          });
                          clickedModal();
                        }}
                      />
                    );
                  },
                },
              ]}
              i18n={i18n}
            />
          </div>
        </Styled.EldContainer>
        <div className="rightSide">
          <Styled.OtherContainer>
            <SubHeader text={i18n.t('OTHER')} className="other" variant="h2" />

            <div className="linkContainer">
              <Table
                type="client"
                defaultSortBy={{ sortBy: 'date', order: 'desc' }}
                title=""
                columns={[...otherItems]}
                itemsPerPage={5}
                pageinationReset={pagination}
                pagenationClicked={(e) => {
                  setPagination(!e);
                }}
                data={generateRows(dailyDocuments.dailyDocumentsOtherFilteredList)}
                emptyMessage={i18n.t('common.tableEmptyMessage')}
                isPaginationNeeded="true"
                actions={[
                  {
                    icon: (row) => {
                      return (
                        <Icon
                          src={mediaUrls?.deleteIcon}
                          onClick={() => {
                            setbackgroundModal(true);
                            setwithCloseIcon(false);
                            setModalObject({
                              content: () => (
                                <Styled.ModalWrapper className="deleteParent">
                                  <div className="imageSection">
                                    <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                                  </div>
                                  <h2> {i18n.t('common.sureConfirm')} </h2>
                                  <div className="deletePopupBtn">
                                    <div className="cancelBtn">
                                      <Button
                                        label={i18n.t('Cancel')}
                                        type={'reset'}
                                        onClick={() => {
                                          closeModal();
                                        }}
                                      ></Button>
                                    </div>
                                    <div className="deletebtn">
                                      <Button
                                        label={i18n.t('trailers.deleteIt')}
                                        onClick={() => {
                                          handleDeleteAlert({
                                            id: 'deleteAlert',
                                            data: {
                                              id: row?.documentId,
                                              type: row?.type,
                                            },
                                            callback: callback,
                                          });
                                          closeModal();
                                        }}
                                      ></Button>
                                    </div>
                                  </div>
                                </Styled.ModalWrapper>
                              ),
                            });
                            clickedModal();
                          }}
                        />
                      );
                    },
                  },
                ]}
                i18n={i18n}
              />
            </div>
          </Styled.OtherContainer>
        </div>
      </div>
      <Modal.default
        open={open}
        setOpen={setOpen}
        data={
          ModalObject || {
            header: '',
            content: () => {},
          }
        }
        onCloseModal={closeModal}
        background="black"
        withCloseIcon={withCloseIcon}
        backgroundModal={backgroundModal}
        deletePopup
      />
    </Styled.DailyLogContainer>
  );
};

Component.defaultProps = {
  drivers: {},
  regions: {},
};

Component.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
